<template>
<div class="ad-root" :style="themePageStyle">

  <div class="ad-progress"><div class="ad-progress-fill" :style="{width:scrollPct+'%'}"></div></div>

  <nav class="ad-topbar">
    <div class="ad-tb-inner">
      <button class="ad-back" @click="goBack"><i class="mdi mdi-arrow-left"></i></button>
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" class="ad-logo" /></a>
      <span class="ad-tb-title">Learning Hub</span>
      <button class="ad-tb-all" @click="$router.push('/learn')"><i class="mdi mdi-book-multiple"></i> All</button>
    </div>
  </nav>

  <div class="ad-wrap">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!article" class="ad-empty">
      <i class="mdi mdi-book-cancel-outline"></i>
      <h5>Article not found</h5>
      <p>{{ error || 'It may have been unpublished or removed.' }}</p>
      <button class="btn btn-warning" @click="$router.push('/learn')">Browse all articles</button>
    </div>

    <article v-else class="ad-article">
      <div v-if="article.cover_image_url" class="ad-cover" :style="'background-image:url('+imgUrl(article.cover_image_url)+')'"></div>

      <span v-if="article.category_name" class="ad-cat">{{ article.category_name }}</span>
      <h1 class="ad-title">{{ article.title }}</h1>

      <div class="ad-byline">
        <user-avatar :name="article.author_name || 'Flockr'" :src="article.author_avatar || ''" size="md" />
        <div class="ad-byline-body">
          <div class="ad-author">{{ (article.author_name && article.author_name.trim()) || 'Flockr Team' }}</div>
          <div class="ad-subline">
            <span v-if="article.published_at">{{ fmtDate(article.published_at) }}</span>
            <span>· {{ readMins }} min read</span>
            <span>· <i class="mdi mdi-eye-outline"></i> {{ article.view_count }}</span>
            <span v-if="article.target_audience">· {{ humanize(article.target_audience) }}</span>
          </div>
        </div>
      </div>

      <p v-if="article.excerpt" class="ad-excerpt">{{ article.excerpt }}</p>

      <div class="ad-body" v-html="renderedContent"></div>

      <!-- engagement bar -->
      <div class="ad-engage">
        <div v-if="Number(article.reaction_count)>0 || Number(article.comment_count)>0" class="ad-engage-counts">
          <span v-if="Number(article.reaction_count)>0"><i class="mdi mdi-thumb-up"></i> {{ article.reaction_count }}</span>
          <span v-if="Number(article.comment_count)>0" style="margin-left:auto;cursor:pointer" @click="scrollComments">{{ article.comment_count }} comment{{ Number(article.comment_count)>1?'s':'' }}</span>
        </div>
        <div class="ad-actions">
          <button class="ad-act" :class="{liked:article.my_reaction}" @click="likeArticle"><i class="mdi" :class="article.my_reaction?'mdi-thumb-up':'mdi-thumb-up-outline'"></i> Like</button>
          <button class="ad-act" @click="scrollComments"><i class="mdi mdi-comment-outline"></i> Comment</button>
          <button class="ad-act" :class="{shared:shared}" @click="shareArticle"><i class="mdi mdi-share-outline"></i> {{ shared?'Shared':'Share' }}</button>
        </div>
      </div>

      <!-- comments -->
      <div class="ad-comments" ref="comments">
        <h6 class="ad-comments-head">{{ Number(article.comment_count)||0 }} comment{{ Number(article.comment_count)===1?'':'s' }}</h6>
        <div v-if="replyTo" class="ad-reply-chip">Replying to <strong>{{ replyTo.author_name || 'a farmer' }}</strong><i class="mdi mdi-close" @click="cancelReply"></i></div>
        <div class="ad-comment-compose">
          <user-avatar :name="myName" :src="myAvatar" size="sm" />
          <input v-model="commentInput" class="ad-comment-input" :placeholder="replyTo ? 'Write a reply…' : 'Write a comment…'" @keyup.enter="postComment" />
          <button class="ad-comment-send" @click="postComment" :disabled="commentBusy || !commentInput.trim()"><i class="mdi mdi-send"></i></button>
        </div>
        <div v-for="c in topComments" :key="c.id" class="ad-comment">
          <user-avatar :src="c.author_avatar" :name="c.author_name" size="sm" />
          <div class="ad-comment-col">
            <div class="ad-comment-bubble">
              <div class="ad-comment-author">{{ c.author_name && c.author_name.trim() ? c.author_name : 'A farmer' }}</div>
              <div class="ad-comment-text">{{ c.content }}</div>
            </div>
            <div class="ad-comment-foot"><span>{{ relTime(c.created_at) }}</span><button class="ad-reply-btn" @click="startReply(c)">Reply</button></div>
            <div v-for="r in repliesOf(c.id)" :key="r.id" class="ad-comment ad-reply">
              <user-avatar :src="r.author_avatar" :name="r.author_name" size="sm" />
              <div class="ad-comment-col">
                <div class="ad-comment-bubble">
                  <div class="ad-comment-author">{{ r.author_name && r.author_name.trim() ? r.author_name : 'A farmer' }}</div>
                  <div class="ad-comment-text">{{ r.content }}</div>
                </div>
                <div class="ad-comment-foot"><span>{{ relTime(r.created_at) }}</span><button class="ad-reply-btn" @click="startReply(c)">Reply</button></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ad-share">
        <button class="ad-share-btn" @click="$router.push('/forum')"><i class="mdi mdi-forum"></i> Discuss in the Forum</button>
        <button class="ad-share-btn" @click="$router.push('/learn')"><i class="mdi mdi-book-open-page-variant"></i> More articles</button>
      </div>

      <div v-if="related.length" class="ad-related">
        <h6 class="ad-related-head">Read next</h6>
        <div class="ad-related-grid">
          <div v-for="a in related" :key="a.id" class="ad-rel-card" @click="goArticle(a)">
            <div class="ad-rel-cover" :style="coverStyle(a)"><i v-if="!a.cover_image_url" class="mdi" :class="catIcon(a.category_name)"></i></div>
            <div class="ad-rel-body">
              <span class="ad-cat sm">{{ a.category_name }}</span>
              <div class="ad-rel-title">{{ a.title }}</div>
              <div class="ad-rel-meta"><i class="mdi mdi-eye-outline"></i> {{ a.view_count }} · <i class="mdi mdi-heart-outline"></i> {{ a.like_count }}</div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F0EBE4;--fm-bg3:#E9E4DC;--fm-br:#E2DCD3}
html[data-theme="light"] body{background:#EBE7E1!important}
html[data-theme="light"] .ad-root{background:#EBE7E1!important;color:#1A1A1A!important}
html[data-theme="light"] .ad-topbar{background:#FFFFFF!important;border-bottom-color:#E2DCD3!important}
html[data-theme="light"] .ad-article,
html[data-theme="light"] .ad-rel-card{background:#FFFFFF!important;border-color:#E2DCD3!important}
html[data-theme="light"] .ad-body{color:#1A1A1A!important}
html[data-theme="light"] .ad-share-btn{background:#EBE7E1!important;color:#1A1A1A!important;border-color:#E2DCD3!important}
html[data-theme="light"] .ad-comment-bubble,
html[data-theme="light"] .ad-comment-input{background:#EBE7E1!important;color:#1A1A1A!important}
html[data-theme="light"] .ad-act:hover{background:#EFEAE3!important}
</style>

<style scoped>
.ad-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.ad-progress{position:fixed;top:0;left:0;right:0;height:3px;z-index:300;background:transparent}
.ad-progress-fill{height:100%;background:linear-gradient(90deg,#BFA164,#E5C77E);width:0;transition:width .1s linear}
.ad-topbar{position:sticky;top:0;z-index:100;background:var(--fm-bg1,#141414);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.ad-tb-inner{display:flex;align-items:center;gap:12px;max-width:760px;margin:0 auto;padding:10px 14px}
.ad-back{width:38px;height:38px;border-radius:50%;border:none;background:var(--fm-bg2,#0F0F0F);color:var(--fm-h,#F5F0E8);font-size:20px}
.ad-logo{height:30px}
.ad-tb-title{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:15px;flex:1}
.ad-tb-all{background:rgba(191,161,100,.12);border:none;color:#BFA164;font-weight:700;font-size:13px;padding:8px 12px;border-radius:8px}
.ad-wrap{max-width:760px;margin:0 auto;padding:18px 14px 70px}

.ad-empty{text-align:center;padding:60px 20px}
.ad-empty i{font-size:64px;color:var(--fm-s,#3A3530)}
.ad-empty h5{color:var(--fm-h,#F5F0E8);margin:12px 0}
.ad-empty p{color:var(--fm-s,#6B6356)}

.ad-article{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:16px;padding:30px 34px 36px}
.ad-cover{height:340px;background-size:cover;background-position:center;border-radius:12px;margin:-30px -34px 24px;border-radius:16px 16px 0 0;background-color:var(--fm-bg2,#0F0F0F)}
.ad-cat{display:inline-block;padding:4px 12px;border-radius:6px;background:rgba(191,161,100,.14);color:#BFA164;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1.5px}
.ad-cat.sm{font-size:9px;padding:1px 6px;letter-spacing:.5px}
.ad-title{color:var(--fm-h,#F5F0E8);font-family:Georgia,'Times New Roman','Noto Serif',serif;font-weight:700;line-height:1.18;font-size:36px;letter-spacing:-.5px;margin:14px 0 16px}
.ad-byline{display:flex;align-items:center;gap:10px;padding-bottom:18px;border-bottom:1px solid var(--fm-br,#1E1E1E);margin-bottom:8px}
.ad-byline-body{min-width:0}
.ad-author{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:14px}
.ad-subline{color:var(--fm-s,#6B6356);font-size:12px;display:flex;flex-wrap:wrap;gap:5px;margin-top:2px}
.ad-subline i{font-size:12px}
.ad-excerpt{color:var(--fm-m,#A09888);font-family:Georgia,'Times New Roman',serif;font-size:20px;line-height:1.55;margin:18px 0 22px;font-style:italic}
.ad-body{color:var(--fm-h,#F5F0E8);font-family:Georgia,'Times New Roman','Noto Serif',serif;font-size:19px;line-height:1.85;max-width:640px;margin:0 auto}
.ad-body :deep(p:first-of-type::first-letter){float:left;font-family:Georgia,serif;font-size:4em;line-height:.72;padding:8px 12px 0 0;color:#BFA164;font-weight:700}
.ad-body :deep(h1),.ad-body :deep(h2),.ad-body :deep(h3){color:var(--fm-h,#F5F0E8);font-family:Georgia,'Times New Roman',serif;margin-top:1.6em;margin-bottom:.4em;font-weight:700;letter-spacing:-.2px}
.ad-body :deep(h2){font-size:26px}
.ad-body :deep(h2)::after{content:"";display:block;width:46px;height:3px;background:#BFA164;border-radius:2px;margin-top:10px}
.ad-body :deep(h3){font-size:21px}
.ad-body :deep(p){margin-bottom:1.1em;color:var(--fm-h,#F5F0E8)}
.ad-body :deep(ul),.ad-body :deep(ol){margin-bottom:1.1em;padding-left:1.4em}
.ad-body :deep(li){margin-bottom:.5em}
.ad-body :deep(a){color:#BFA164;text-decoration:underline}
.ad-body :deep(blockquote){border-left:4px solid #BFA164;padding:10px 0 10px 20px;margin:1.4em 0;color:var(--fm-h,#F5F0E8);font-style:italic;font-size:22px;line-height:1.5}
.ad-body :deep(img){max-width:100%;border-radius:10px;margin:1.4em 0}
.ad-body :deep(table){width:100%;border-collapse:collapse;margin:1.4em 0;font-size:15px;font-family:system-ui,-apple-system,sans-serif}
.ad-body :deep(th),.ad-body :deep(td){border:1px solid var(--fm-br,#1E1E1E);padding:9px 12px;text-align:left}
.ad-body :deep(th){background:var(--fm-bg2,#0F0F0F);color:#BFA164}

.ad-engage{margin-top:28px;padding-top:14px;border-top:1px solid var(--fm-br,#1E1E1E)}
.ad-engage-counts{display:flex;align-items:center;gap:6px;font-size:13px;color:var(--fm-s,#6B6356);padding-bottom:8px}
.ad-engage-counts i{color:#fff;border-radius:50%;font-size:10px;width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(#18AFFF,#0062DF)}
.ad-actions{display:flex;gap:4px;border-top:1px solid var(--fm-br,#1E1E1E);padding-top:6px}
.ad-act{flex:1;background:transparent;border:none;color:var(--fm-m,#A09888);font-size:14px;font-weight:700;padding:9px;border-radius:8px;display:flex;align-items:center;justify-content:center;gap:8px;font-family:system-ui,-apple-system,sans-serif}
.ad-act:hover{background:var(--fm-bg2,#0F0F0F)}
.ad-act.liked{color:#1877F2}
.ad-act.shared{color:#45BD62}
.ad-act i{font-size:20px}
.ad-comments{margin-top:18px;font-family:system-ui,-apple-system,sans-serif}
.ad-comments-head{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:15px;margin-bottom:12px}
.ad-comment-compose{display:flex;align-items:center;gap:8px;margin-bottom:16px}
.ad-comment-input{flex:1;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:20px;padding:9px 14px;color:var(--fm-h,#F5F0E8);font-size:14px;outline:none}
.ad-comment-input:focus{border-color:#BFA164}
.ad-comment-send{background:#BFA164;border:none;color:#0A0A0A;border-radius:50%;width:36px;height:36px;font-size:18px;flex-shrink:0}
.ad-comment-send:disabled{opacity:.4}
.ad-comment{display:flex;gap:8px;margin-bottom:12px}
.ad-comment-col{flex:1;min-width:0}
.ad-comment-bubble{background:var(--fm-bg2,#0F0F0F);border-radius:16px;padding:8px 12px;display:inline-block;max-width:100%}
.ad-comment-author{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:13px}
.ad-comment-text{color:var(--fm-h,#F5F0E8);font-size:14px;white-space:pre-wrap}
.ad-comment-time{color:var(--fm-s,#6B6356);font-size:11px;margin:3px 0 0 12px}
.ad-comment-foot{display:flex;align-items:center;gap:14px;margin:3px 0 0 12px;font-size:11px;color:var(--fm-s,#6B6356)}
.ad-reply-btn{background:none;border:none;color:var(--fm-s,#6B6356);font-weight:700;font-size:12px;padding:0;cursor:pointer}
.ad-reply-btn:hover{color:#BFA164}
.ad-reply{margin-top:10px;margin-left:14px}
.ad-reply-chip{display:inline-flex;align-items:center;gap:6px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:14px;padding:4px 10px;font-size:12px;color:var(--fm-m,#A09888);margin-bottom:8px}
.ad-reply-chip i{cursor:pointer;font-size:15px}
.ad-reply-chip i:hover{color:#FF6B6B}
.ad-share{display:flex;gap:10px;flex-wrap:wrap;margin-top:28px;padding-top:18px;border-top:1px solid var(--fm-br,#1E1E1E)}
.ad-share-btn{flex:1;min-width:160px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);color:var(--fm-h,#F5F0E8);border-radius:10px;padding:11px;font-weight:700;font-size:14px;display:flex;align-items:center;justify-content:center;gap:8px}
.ad-share-btn:hover{border-color:#BFA164;color:#BFA164}
.ad-share-btn i{font-size:18px}

.ad-related{margin-top:28px}
.ad-related-head{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:16px;margin-bottom:12px}
.ad-related-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:12px}
.ad-rel-card{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;overflow:hidden;cursor:pointer}
.ad-rel-card:hover{border-color:#BFA164}
.ad-rel-cover{height:90px;background-size:cover;background-position:center;background-color:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;color:rgba(191,161,100,.5);font-size:28px}
.ad-rel-body{padding:10px}
.ad-rel-title{color:var(--fm-h,#F5F0E8);font-weight:700;font-size:13px;line-height:1.3;margin:4px 0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.ad-rel-meta{color:var(--fm-s,#6B6356);font-size:11px}

@media (max-width:600px){.ad-tb-title{display:none}.ad-title{font-size:23px}}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  /* Tight sticky topbar */
  .ad-topbar { padding: 6px 0 !important; }
  .ad-tb-inner { gap: 8px !important; padding: 6px 10px !important; }
  .ad-back { width: 36px !important; height: 36px !important; font-size: 18px !important; }
  .ad-logo { height: 26px !important; }
  .ad-tb-all { font-size: 11px !important; padding: 6px 8px !important; }

  /* Edge-to-edge cover, no big top gap */
  .ad-wrap { padding: 0 0 calc(40px + env(safe-area-inset-bottom, 0px)) !important; max-width: 100% !important; box-sizing: border-box !important; overflow-x: hidden !important; }
  .ad-article { padding: 0 !important; }
  .ad-cover { aspect-ratio: 16/9 !important; border-radius: 0 !important; margin-bottom: 14px !important; }
  .ad-article > :not(.ad-cover):not(.ad-comments):not(.ad-related):not(.ad-share) { padding-left: 14px !important; padding-right: 14px !important; }

  /* Title + byline */
  .ad-cat { font-size: 9px !important; padding: 2px 7px !important; margin-bottom: 6px !important; }
  .ad-title { font-size: 22px !important; line-height: 1.25 !important; margin-bottom: 6px !important; }
  .ad-byline { gap: 8px !important; margin-bottom: 14px !important; }
  .ad-author { font-size: 12px !important; }
  .ad-subline { font-size: 10px !important; flex-wrap: wrap; gap: 6px !important; }

  .ad-excerpt { font-size: 14px !important; line-height: 1.55 !important; margin-bottom: 14px !important; padding-left: 10px !important; border-left: 3px solid #BFA164; }

  /* Body type: large enough to read on a phone without zoom */
  .ad-body { font-size: 15px !important; line-height: 1.7 !important; }
  .ad-body h1,.ad-body h2 { font-size: 17px !important; margin-top: 18px !important; }
  .ad-body h3,.ad-body h4 { font-size: 15px !important; margin-top: 14px !important; }
  .ad-body p { margin-bottom: 12px !important; }
  .ad-body ul, .ad-body ol { padding-left: 20px !important; }
  .ad-body img { width: 100% !important; height: auto !important; border-radius: 8px !important; margin: 10px 0 !important; }

  /* Engagement bar — pill-style row */
  .ad-engage { padding: 10px 14px !important; margin: 14px 0 !important; }
  .ad-engage-counts { font-size: 11px !important; padding-bottom: 8px !important; }
  .ad-actions { gap: 6px !important; }
  .ad-act { font-size: 12px !important; padding: 8px 6px !important; }

  /* Comments */
  .ad-comments { padding: 12px 14px !important; margin: 0 !important; border-radius: 0 !important; }
  .ad-comments-head { font-size: 13px !important; margin-bottom: 8px !important; }
  .ad-comment-compose { padding: 6px 10px !important; gap: 6px !important; }
  .ad-comment-input { font-size: 13px !important; }
  .ad-comment-send { width: 32px !important; height: 32px !important; font-size: 14px !important; }
  .ad-comment { gap: 8px !important; }
  .ad-comment-bubble { padding: 8px 10px !important; }
  .ad-comment-author { font-size: 12px !important; }
  .ad-comment-text { font-size: 12px !important; line-height: 1.5 !important; }
  .ad-comment-foot { font-size: 10px !important; }
  .ad-reply { margin-left: 22px !important; }

  /* "Discuss in the forum" / "More articles" CTA row */
  .ad-share { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 8px !important; padding: 12px 14px !important; }
  .ad-share-btn { font-size: 12px !important; padding: 10px 8px !important; }

  /* Related articles */
  .ad-related { padding: 12px 14px !important; }
  .ad-related-head { font-size: 13px !important; margin-bottom: 8px !important; }
  .ad-related-grid { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 8px !important; }
  .ad-rel-card { padding: 0 !important; border-radius: 10px !important; overflow: hidden; }
  .ad-rel-cover { height: 84px !important; }
  .ad-rel-body { padding: 8px !important; }
  .ad-rel-title { font-size: 11px !important; line-height: 1.3 !important; }
  .ad-rel-meta { font-size: 9px !important; }

  /* Reading-progress bar at the very top — keep but slim */
  .ad-progress { height: 2px !important; }
}

/* Very small phones — drop the "All" pill text to icon */
@media (max-width: 380px) {
  .ad-tb-all span:not(.mdi) { display: none; }
}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker, uploads } from "@/api";
import UserAvatar from "@/components/flockr-users/UserAvatar.vue";

export default {
  name: "ArticleDetail",
  components: { UserAvatar },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,loading:true,error:'',article:null,related:[],scrollPct:0,_onScroll:null,
    comments:[],commentInput:'',commentBusy:false,shared:false,replyTo:null,
    _grads:['linear-gradient(135deg,#2a2418,#14110a)','linear-gradient(135deg,#182a1a,#0a140b)','linear-gradient(135deg,#181f2a,#0a0d14)','linear-gradient(135deg,#2a182a,#140a14)','linear-gradient(135deg,#2a1818,#140a0a)']
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#EBE7E1;min-height:100vh;color:#1A1A1A;'},
    myUserId(){return sessionStorage.getItem('userId')||''},
    myName(){return sessionStorage.getItem('userName')||'You'},
    myAvatar(){return sessionStorage.getItem('userAvatar')||''},
    topComments(){return (this.comments||[]).filter(function(c){return !c.parent_comment_id;});},
    readMins(){
      if(!this.article||!this.article.content) return 1;
      var text=String(this.article.content).replace(/<[^>]+>/g,' ');
      var words=(text.trim().match(/\S+/g)||[]).length;
      return Math.max(1, Math.round(words/200));
    },
    renderedContent(){
      if (!this.article || !this.article.content) return '';
      var c = this.article.content;
      if (/<(p|h[1-6]|ul|ol|table|blockquote|div)/i.test(c)) return c;
      return c.split(/\n\n+/).map(function(para){
        para = para.trim(); if (!para) return '';
        if (para.indexOf('## ') === 0) return '<h2>' + para.substring(3) + '</h2>';
        if (para.indexOf('# ') === 0)  return '<h1>' + para.substring(2) + '</h1>';
        return '<p>' + para.replace(/\n/g, '<br/>') + '</p>';
      }).join('\n');
    }
  },
  watch: {
    '$route.params.idOrSlug'(){this.load()}
  },
  mounted(){
    this._applyThemeOnce();
    var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.load();
    var self=this;
    this._onScroll=function(){
      var el=document.documentElement;
      var st=el.scrollTop||document.body.scrollTop||0;
      var h=(el.scrollHeight-el.clientHeight)||1;
      self.scrollPct=Math.min(100,Math.max(0,(st/h)*100));
    };
    window.addEventListener('scroll', this._onScroll, {passive:true});
  },
  beforeUnmount(){
    if(this.themeObserver){this.themeObserver.disconnect();this.themeObserver=null}
    if(this._onScroll) window.removeEventListener('scroll', this._onScroll);
  },
  methods:{
    _applyThemeOnce(){
      var current=document.documentElement.getAttribute('data-theme');
      var desired=(localStorage.getItem('flockr_theme')||current||'dark');
      if(current!==desired) document.documentElement.setAttribute('data-theme',desired);
      this.darkMode=desired!=='light';
    },
    goBack(){ if(window.history.length>1) this.$router.go(-1); else this.$router.push('/learn'); },
    imgUrl(u){if(!u)return'';if(u.indexOf('http')===0)return u;return uploads+String(u).replace(/^uploads\//,'');},
    humanize(s){return (s||'').charAt(0).toUpperCase()+ (s||'').slice(1);},
    fmtDate(ts){ if(!ts) return ''; var d=new Date(String(ts).replace(' ','T')); return d.toLocaleDateString('en',{day:'numeric',month:'short',year:'numeric'}); },
    catIcon(name){
      var n=(name||'').toLowerCase();
      if(n.indexOf('health')>-1||n.indexOf('disease')>-1) return 'mdi-heart-pulse';
      if(n.indexOf('feed')>-1||n.indexOf('nutri')>-1) return 'mdi-grain';
      if(n.indexOf('breed')>-1) return 'mdi-baby-carriage';
      if(n.indexOf('market')>-1||n.indexOf('price')>-1) return 'mdi-chart-line';
      if(n.indexOf('dairy')>-1||n.indexOf('milk')>-1) return 'mdi-cup-water';
      if(n.indexOf('poultry')>-1||n.indexOf('chick')>-1) return 'mdi-egg';
      if(n.indexOf('equip')>-1) return 'mdi-tractor';
      return 'mdi-book-open-variant';
    },
    coverStyle(a){
      if(a && a.cover_image_url) return 'background-image:url('+this.imgUrl(a.cover_image_url)+')';
      var id=Number(a&&a.id)||0; return 'background-image:'+this._grads[id % this._grads.length];
    },
    goArticle(a){ this.$router.push('/learn/'+(a.slug||a.id)); window.scrollTo(0,0); },
    async load(){
      this.loading=true;this.error='';this.article=null;this.related=[];this.comments=[];this.shared=false;this.commentInput='';
      var idOrSlug=this.$route.params.idOrSlug;
      var params={function:'getArticleDetail',userId:this.myUserId};
      if(/^\d+$/.test(idOrSlug)) params.articleId=idOrSlug;
      else params.slug=idOrSlug;
      try{
        var r=await executeJson(params,flocker);
        if(r.data&&r.data.success&&r.data.data&&r.data.data.article){
          this.article=r.data.data.article;
          this.loadRelated();
          this.loadComments();
        }else{
          this.error=(r.data&&r.data.message)||'Article not found';
        }
      }catch(e){this.error=(e&&e.message)||'Network error'}
      this.loading=false;
    },
    relTime(ts){
      if(!ts) return '';
      var diff=Math.floor((Date.now()-new Date(String(ts).replace(' ','T')).getTime())/1000);
      if(diff<60) return 'just now';
      if(diff<3600) return Math.floor(diff/60)+'m';
      if(diff<86400) return Math.floor(diff/3600)+'h';
      if(diff<2592000) return Math.floor(diff/86400)+'d';
      return String(ts).split(' ')[0];
    },
    async loadComments(){
      try{var r=await executeJson({function:'getContentComments',targetType:'article',targetId:this.article.id},flocker);
        if(r.data&&r.data.success)this.comments=(r.data.data&&r.data.data.comments)||[];}catch(e){}
    },
    async likeArticle(){
      if(!this.myUserId){this.$router.push('/login?redirect=/learn/'+this.$route.params.idOrSlug);return}
      try{var r=await executeJson({function:'reactToPost',userId:this.myUserId,targetType:'article',targetId:this.article.id,reaction:'like'},flocker);
        if(r.data&&r.data.success){this.article.reaction_count=r.data.data.reactionCount;this.article.my_reaction=r.data.data.myReaction;}}catch(e){}
    },
    scrollComments(){ var self=this; this.$nextTick(function(){ if(self.$refs.comments) self.$refs.comments.scrollIntoView({behavior:'smooth',block:'start'}); }); },
    repliesOf(id){ return (this.comments||[]).filter(function(c){return String(c.parent_comment_id)===String(id);}); },
    startReply(c){ this.replyTo=c; this.scrollComments(); },
    cancelReply(){ this.replyTo=null; },
    async postComment(){
      var txt=(this.commentInput||'').trim(); if(!txt)return;
      if(!this.myUserId){this.$router.push('/login?redirect=/learn/'+this.$route.params.idOrSlug);return}
      this.commentBusy=true;
      var pid = this.replyTo ? this.replyTo.id : 0;
      try{var r=await executeJson({function:'addContentComment',authorId:this.myUserId,targetType:'article',targetId:this.article.id,content:txt,parentId:pid},flocker);
        if(r.data&&r.data.success){this.commentInput='';this.replyTo=null;this.article.comment_count=r.data.data.commentCount;await this.loadComments();}}catch(e){}
      this.commentBusy=false;
    },
    async shareArticle(){
      if(!this.myUserId){this.$router.push('/login?redirect=/learn/'+this.$route.params.idOrSlug);return}
      var url='/learn/'+(this.article.slug||this.article.id);
      var note='📖 '+this.article.title+'\n\nWorth a read on the Flockr Learning Hub: '+url;
      try{var r=await executeJson({function:'createFeedPost',authorId:this.myUserId,content:note,category:'general'},flocker);
        if(r.data&&r.data.success)this.shared=true;}catch(e){}
    },
    async loadRelated(){
      try{
        var params={function:'getArticles',limit:6};
        if(this.article.category_slug) params.categorySlug=this.article.category_slug;
        var r=await executeJson(params,flocker);
        if(r.data&&r.data.success){
          var self=this;
          this.related=((r.data.data&&r.data.data.articles)||[]).filter(function(a){return String(a.id)!==String(self.article.id);}).slice(0,3);
        }
      }catch(e){}
    }
  }
};
</script>
